export const FORM_KEYS = {
  TABLE_WRAPPER: {
    key: 'operatingModelList',
  },
  TITLE: {
    label: 'Title',
    key: 'name',
    placeholder: 'Please enter the title here',
  },
  SUMMARY: {
    label: 'Summary',
    key: 'summary',
    placeholder: 'Please enter the summary here',
  },
  DES: {
    label: 'Description',
    key: 'activities',
    placeholder: 'Please enter the description here',
  },
  DRAG: {
    key: 'drag',
  },
};
